import { render, staticRenderFns } from "./SingleReceivedCard.vue?vue&type=template&id=ef97cb42&scoped=true"
import script from "./SingleReceivedCard.vue?vue&type=script&lang=js"
export * from "./SingleReceivedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef97cb42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef97cb42')) {
      api.createRecord('ef97cb42', component.options)
    } else {
      api.reload('ef97cb42', component.options)
    }
    module.hot.accept("./SingleReceivedCard.vue?vue&type=template&id=ef97cb42&scoped=true", function () {
      api.rerender('ef97cb42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/SingleReceivedCard.vue"
export default component.exports